import { jsx as E } from "react/jsx-runtime";
import { Elements as S } from "../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { centsToUnits as x } from "@systemeio/ui";
import { PricePlanTypeEnum as v } from "../../libs/types/dist/index9.mjs";
import { useMemo as d } from "react";
import { useStore as P, useOfferStore as _ } from "../../store/index.mjs";
import { zeroDecimalCurrencies as b } from "./constants/zero-decimal-currencies.mjs";
import { useStripeProvider as B } from "./stripe-provider.mjs";
import { StripePaymentMethodUsingPaymentElementEnum as i } from "./enum/stripe-payment-method-using-payment-element-enum.mjs";
import { IntentTypeEnum as e } from "./enum/intent-type-enum.mjs";
import { useDesignContext as D } from "../../providers/use-design-provider.mjs";
import { getColors as I } from "../../themes/utils/color-utils.mjs";
function N({ children: y, paymentMethodType: t }) {
  var f;
  const { stripePromise: C } = B(), { locale: m } = P(), { currency: n, finalAmount: o, pricePlan: r } = _(), { state: g } = D(), { primaryColor: u, textColorSecondary: p, secondaryColor: c } = I(g), s = d(() => o ? t === i.Klarna && (r == null ? void 0 : r.type) !== v.one_shot && (r != null && r.recurringOptions.trialPeriod) ? e.setup : t === i.Ideal || t === i.Bancontact ? e.setup : e.payment : e.setup, [o, t, (f = r == null ? void 0 : r.recurringOptions) == null ? void 0 : f.trialPeriod, r == null ? void 0 : r.type]), a = d(() => {
    if (!n) return;
    const l = {
      payment_method_types: [t],
      currency: n,
      locale: m,
      appearance: {
        variables: {
          colorPrimary: u,
          colorBackground: c,
          colorText: p
        }
      }
    };
    if (s === e.setup)
      return {
        ...l,
        mode: s
      };
    {
      if (!o) return;
      const O = b.includes(n) ? x(o) : o;
      return {
        ...l,
        paymentMethodCreation: "manual",
        mode: s,
        amount: O
      };
    }
  }, [
    n,
    o,
    m,
    s,
    t,
    u,
    c,
    p
  ]);
  return a && /* @__PURE__ */ E(S, { stripe: C, options: a, children: y });
}
export {
  N as StripeElementsProvider
};
